<template>
    <footer class="relative w-full bg-[var(--background-primary)] backdrop-blur-sm py-4
           before:absolute before:top-0 before:left-0 before:w-full before:h-[1px]
           before:bg-[linear-gradient(90deg,rgba(42,42,64,0)_0%,#2A2A40_49.9%,rgba(42,42,64,0)_100%)]">
        <div
            class="max-w-screen-xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center text-sm text-[var(--text-muted)]">

            <!-- Left Links -->
            <div class="flex items-center space-x-2">
                <NuxtLink to="/privacy" class="hover:text-[var(--primary-hover)] transition-colors">
                    Privacy Notice
                </NuxtLink>
                <span>•</span>
                <NuxtLink to="/terms" class="hover:text-[var(--primary-hover)] transition-colors">
                    Site Terms
                </NuxtLink>
                <span>•</span>
                <NuxtLink to="/contact" class="hover:text-[var(--primary-hover)] transition-colors">
                    Contact us
                </NuxtLink>
            </div>

            <!-- Right Copyright -->
            <div class="mt-2 md:mt-0">
                ©2025 <span class="font-semibold">Nuxt.store</span> All Rights Reserved
            </div>
        </div>
    </footer>
</template>
